import _ from 'lodash-es';

export default class MfPopupController {
	#open;

	/* @ngInject */
	/**
	 * @param {any} User
	 */
	constructor(User) {
		this.User = User;

		/** @type {boolean} */
		this.#open = false;

		/** @type {any} */
		this.active = {};

		/** @type {boolean} */
		this.allcheck = false;

		/** @type {any} */
		this.assignIsOpen = undefined;

		/** @type {{ from: number, to: number; } | undefined} */
		this.card = undefined;

		/** @type {boolean} */
		this.collapse = false;

		/** @type {boolean} */
		this.create = false;

		this.expand = undefined;
		this.majpressed = undefined;

		/** @type {number} */
		this.mapIndex = -1;

		/** @type {any[]} */
		this.mapPath = [];

		/** @type {any[]} */
		this.matches = [];

		this.moveInProgress = undefined;
		this.multipleSelection = undefined;
		this.openForm = undefined;
		this.options = undefined;
		this.order = undefined;
		this.position = undefined;

		/** @type {?string} */
		this.query = null;

		/** @type {?Function} */
		this.select = null;

		/** @type {any[]} */
		this.selectlist = [];

		/** @type {boolean} */
		this.showSuggestion = false;

		this.showMultipleSelectionHint = true;
		this.values = undefined;
	}

	/**
	 * Check if an element has selectable child elements
	 *
	 * @param {any} match Match object
	 * @returns {boolean} Return true if the element has selectable child elements
	 */
	// eslint-disable-next-line class-methods-use-this
	hasChild(match) {
		let childCount = 0;

		if (match.length > 0) {
			for (const value of match) {
				if (value.selectable === 1) {
					childCount++;
				}
			}

			return childCount !== 0;
		}

		return false;
	}

	/**
	 * @param {any} match
	 * @returns {boolean}
	 */
	isActive(match) {
		return this.active.item && _.isEqual(this.active.item.path, match.path);
	}

	isOpen() {
		const isDropdownOpen = (((!this.create && this.matches && this.matches.length > 0)
			|| (!!this.create && this.matches && this.matches.length > 1))
			&& typeof this.query === 'string' && this.query.length > 0) || this.showSuggestion;
		this.assignIsOpen({ isOpen: isDropdownOpen });

		if (this.#open && !isDropdownOpen && this.multipleSelection) {
			if (this.selectlist.length > 0 && this.select) {
				for (const value of this.selectlist) {
					this.select(value);
				}
			}
			this.multipleSelection = false;
		}
		this.#open = isDropdownOpen;

		this.showMultipleSelectionHint = this.#open
			&& this.card !== undefined
			&& this.card.to > 1
			&& this.matches.length > 0
			&& this.User.getSetting('mf-multiple-selection-hint-removed') !== true;

		return isDropdownOpen;
	}

	/**
	 * @param {any} item
	 * @param {Event} event
	 */
	multiSelect(item, event) {
		if (this.selectlist.some(elementSelected => elementSelected.item === item)) {
			item.checked = false;
			this.selectlist.splice(this.selectlist.findIndex(elementSelected => elementSelected.item === item), 1);
		}
		else {
			item.checked = true;
			this.selectlist.push({ item, event });
		}
	}

	/**
	 * @param {Event} event
	 */
	removeMutlipleSelectionHint(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
		this.showMultipleSelectionHint = false;
		this.User.setSetting('mf-multiple-selection-hint-removed', true);
	}

	/**
	 * @param {any} matches
	 */
	selectAllChildrens(matches) {
		if (this.allcheck === true) {
			for (const item of matches) {
				_.merge(item, { checked: false });
				this.selectlist.splice(this.selectlist.findIndex(elementSelected => elementSelected.item === item), 1);
			}
			this.allcheck = false;
		}
		else if (this.allcheck === false) {
			for (const item of matches) {
				if (item.selectable === 1) {
					_.merge(item, { checked: true });
					this.selectlist.push({ item, event: new Event('multiselect-all') });
				}
			}
			this.allcheck = true;
		}
	}

	/**
	 * @param {any} match
	 */
	selectActive(match) {
		this.active = [...match.path];
		this.mapIndex = this.mapPath.findIndex((/** @type {any} */ item) => _.isEqual(item, this.active));
	}
}
